import React, { useState } from 'react';
import { AdminEntry } from './AdminEntry';
import { Viewer } from './Viewer';
import { MonthlyDates } from './types';
import { Settings, Eye } from 'lucide-react';
import { addDays, format, startOfMonth } from 'date-fns';
import { useScreenInit } from '../../useScreenInit.js';
const today = new Date();
const formatDate = (date: Date) => format(date, 'yyyy-MM-dd');
const currentPeriod = format(startOfMonth(today), 'yyyy-MM');
// Seed the current month so the viewer is populated on first load.
const defaultDates: MonthlyDates = {
  [currentPeriod]: {
    primaryRefi: {
      initialLE: formatDate(addDays(today, -2)),
      signCD: formatDate(addDays(today, 5)),
      close: formatDate(addDays(today, 12))
    },
    secondInvestPurch: {
      initialLE: formatDate(addDays(today, 1)),
      signCD: formatDate(addDays(today, 8)),
      close: formatDate(addDays(today, 15))
    }
  }
};
export function ImportantDatesFeature() {
  const screenInit = useScreenInit();
  const [viewMode, setViewMode] = useState<'viewer' | 'admin'>(screenInit.viewMode === 'admin' ? 'admin' : 'viewer');
  const [periods, setPeriods] = useState<MonthlyDates>(defaultDates);
  return <div className="min-h-screen bg-slate-50 py-12 px-4 sm:px-6 lg:px-8" data-id="element-46">
      <div className="max-w-5xl mx-auto mb-8 flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4" data-id="element-47">
        <div data-id="element-48">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-49">Important Dates</h1>
          <p className="text-slate-500 text-sm mt-1" data-id="element-50">
            Track and manage critical loan milestones
          </p>
        </div>

        <div className="bg-white p-1 rounded-lg border border-slate-200 shadow-sm inline-flex" data-id="element-51">
          <button onClick={() => setViewMode('viewer')} className={`flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium transition-colors ${viewMode === 'viewer' ? 'bg-blue-50 text-blue-700 shadow-sm' : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'}`} data-id="element-52">
            <Eye className="w-4 h-4" data-id="element-53" />
            Viewer
          </button>
          <button onClick={() => setViewMode('admin')} className={`flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium transition-colors ${viewMode === 'admin' ? 'bg-blue-50 text-blue-700 shadow-sm' : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'}`} data-id="element-54">
            <Settings className="w-4 h-4" data-id="element-55" />
            Admin Entry
          </button>
        </div>
      </div>

      {viewMode === 'viewer' ? <Viewer periods={periods} onSwitchToAdmin={() => setViewMode('admin')} data-id="element-56" /> : <AdminEntry periods={periods} onSave={newPeriods => {
      setPeriods(newPeriods);
    }} data-id="element-57" />}
    </div>;
}